import { createSlice } from '@reduxjs/toolkit'

import type { TSocialMediaUser } from '../Users/Users.types'

export interface NewSearchSliceState {
  useCases: {
    selectedUseCaseId: string
    selectedUseCaseName: string
  }

  focusTopics: {
    topics: string[]
  }

  subjectInfo: {
    firstName: string
    middleName: string
    lastName: string
    email: string
    image: string | null
  }

  socialMedias: TSocialMediaUser[]

  reportSetup: {
    pdfLanguage: string
  }
}

export const newSearchInitialState: NewSearchSliceState = {
  useCases: {
    selectedUseCaseId: '',
    selectedUseCaseName: '',
  },

  focusTopics: {
    topics: [],
  },

  subjectInfo: {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    image: '',
  },

  socialMedias: [],

  reportSetup: {
    pdfLanguage: 'en',
  },
}

const newSearchSlice = createSlice({
  name: 'newSearch',
  initialState: newSearchInitialState,
  reducers: {
    setUseCases: (state, action) => {
      const useCases = action.payload
      state.useCases = { ...useCases }
    },

    setFocusTopics: (state, action) => {
      const { topics } = action.payload
      state.focusTopics.topics = topics
    },

    setSubjectInfo: (state, action) => {
      const newSubjectInfo = action.payload
      state.subjectInfo = { ...newSubjectInfo }
    },
    clearSubjectInfo: (state) => {
      state.subjectInfo = { ...newSearchInitialState.subjectInfo }
    },

    setSocialMedias: (state, action) => {
      const socialMedias = action.payload
      state.socialMedias = socialMedias
    },
    clearSocialMedias: (state) => {
      state.socialMedias = []
    },

    setReportSetup: (state, action) => {
      const reportLang = action.payload
      state.reportSetup.pdfLanguage = reportLang
    },

    clearNewSearch: (state) => {
      state = { ...newSearchInitialState }
      return state
    },
  },
})

export const {
  setUseCases,
  setFocusTopics,
  setSubjectInfo,
  clearSubjectInfo,
  setReportSetup,
  clearNewSearch,
} = newSearchSlice.actions

export default newSearchSlice.reducer
